import { Component, Input, OnInit } from '@angular/core';
import { WhiteboardDrawing, WhiteboardDrawingsService } from '@lemberger/whiteboards';
import { HttpClient } from '@angular/common/http';
import {
    WhiteboardDrawingsListItemComponent
} from '../whiteboard-drawings-list-item/whiteboard-drawings-list-item.component';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-whiteboard-search',
    templateUrl: './whiteboard-search.component.html',
    styleUrls: ['./whiteboard-search.component.scss'],
    standalone: true,
    imports: [
        FormsModule
    ]
})
export class WhiteboardSearchComponent implements OnInit {
    @Input() whiteboardList: HTMLUListElement;
    whiteboardsOriginal: Array<WhiteboardDrawing>;
    titleSearch = '';
    schoolGradeSearch;
    subjectSearch;

    subjects;
    schoolGrades = Array.from({ length: 13 }, (_, i) => i + 1);

    constructor(private whiteboardDrawingsService: WhiteboardDrawingsService,
                private applicationStateService: ApplicationStateService,
                private httpClient: HttpClient) {
        this.whiteboardsOriginal = this.whiteboardDrawingsService.getWhiteboardsFromSubject();
    }

    ngOnInit(): void {
        this.httpClient.get(`${this.applicationStateService.baseUrl}/school/subjects`)
            .subscribe((subjects) => {
                this.subjects = subjects;
            });
        this.schoolGradeSearch = null;
        this.subjectSearch = null;
    }

    search(): void {
        let whiteboardsFiltered = this.whiteboardsOriginal;
        if (this.titleSearch) {
            whiteboardsFiltered = whiteboardsFiltered.filter(whiteboardDrawing => {
                return whiteboardDrawing.name.toLowerCase().indexOf(this.titleSearch.toLowerCase()) >= 0;
            });
        }
        if (this.schoolGradeSearch) {
            whiteboardsFiltered = whiteboardsFiltered.filter(whiteboardDrawing => {
                return whiteboardDrawing.school_grade === this.schoolGradeSearch;
            });
        }
        if (this.subjectSearch) {
            whiteboardsFiltered = whiteboardsFiltered.filter(whiteboardDrawing => {
                return whiteboardDrawing.subject_id === this.subjectSearch;
            });
        }
        this.filterElements(whiteboardsFiltered);
    }

    private filterElements(whiteboards: Array<WhiteboardDrawing>): void {
        const whiteboardIds = whiteboards.map(whiteboard => whiteboard.id);
        Array.from(this.whiteboardList.children).forEach((whiteboardLI: HTMLElement) => {
            const liWhiteboardID = +whiteboardLI.id.replace(WhiteboardDrawingsListItemComponent.idPrefix, '');
            if (whiteboardIds.includes(liWhiteboardID)) {
                whiteboardLI.style.display = 'block';
            } else {
                whiteboardLI.style.display = 'none';
            }
        });
    }
}
